import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleHero from './components/ArticleHero';
import ArticleBody from './components/ArticleBody';
import RelatedPosts from './components/RelatedPosts';
import BottomCTA from '@/pages/blog/components/BottomCTA';
import { blogPostingJsonLd } from '@/components/feature/BlogPostingJsonLd';

const jsonLd = blogPostingJsonLd({
  headline: 'Case Study: How Pop Pro Tents Transformed the Experience at Lightning in a Bottle Festival',
  description: 'Discover how Pop Pro Tents custom stretch tent installation elevated the guest experience at one of the most iconic outdoor festivals in the US, with 17 tents across the entire festival grounds.',
  url: `${import.meta.env.VITE_SITE_URL || 'https://popprotents.com'}/blog/lightning-in-a-bottle-festival`,
  datePublished: '2024-09-23',
  dateModified: '2026-06-29',
  authorName: 'Pop Pro Tents Team',
  keywords: ['Lightning in a Bottle', 'festival stretch tent', 'outdoor festival tent', 'event case study', 'festival shelter'],
});

export default function LightningInABottlePage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleBody />
        <RelatedPosts />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}